import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../../actions/navigationActions";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as componentTypes from "../../../../../constants/componentTypes";
import Modal from "../../../../global/generic/Modal";
import CloseButton from "../../../../global/generic/CloseButton";

class DatabaseListModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseDatabaseListModalAction();
    };

    getContent = () => {
        return this.props.databaseList.map((item) => {
            return (
                <div key={item.uuid} className="padding-bottom-10 col-12">
                    <span>{item.name}</span>
                    <ul>
                        {item.main.version ? (
                            <li>
                                <Translate value="general.version" />: {item.main.version}
                            </li>
                        ) : (
                            ""
                        )}
                        {item.main.customerVersion ? (
                            <li>
                                <Translate value="general.customerVersion" />: {item.main.customerVersion}
                            </li>
                        ) : (
                            ""
                        )}
                        <li>
                            <Translate value="customRedlike.uuid" />: {item.uuid}
                        </li>
                        {item.main.shotsCoef ? (
                            <li>
                                <Translate value="customRedlike.shotsCoefficient" />: {item.main.shotsCoef}
                            </li>
                        ) : (
                            ""
                        )}
                    </ul>
                </div>
            );
        });
    };

    render() {
        return (
            <Modal
                className="software-version-modal"
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="customRedlikeSettings.databaseList" />)}
                content={modelHelper.buildModalSection(this.getContent(), "col-12 flex flex-wrap slim-scroll")}
                footer={modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />)}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        databaseList: store.server.databaseList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDatabaseListModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_DATABASE_LIST_MODAL));
        }
    };
};

export default DatabaseListModal = connect(mapStoreToProps, mapDispatchToProps)(DatabaseListModal);
